import { z } from "zod";

export const comparisonRouteSearchSchema = z
  .object({
    range: z.enum(["7d", "30d"]).optional(),
    metric: z.enum(["dimension", "wedge"]).catch("dimension"),
    // `.catch([])` alone resolves a missing/invalid `depts` param to `[]`
    // (verified: chaining a trailing `.default("")` short-circuits before
    // the transform runs and returns the raw default string instead).
    depts: z
      .string()
      .transform((s) => s.split(",").filter(Boolean))
      .catch([]),
  })
  .strict();

export type ComparisonRouteSearch = z.infer<typeof comparisonRouteSearchSchema>;

/// The pre-parse shape: `depts` is the raw csv string here (it's an array
/// only after `comparisonRouteSearchSchema` transforms it). TanStack
/// Router's `navigate({ search })` updater must return this shape, not the
/// parsed `ComparisonRouteSearch`, since the value it returns is what gets
/// serialized into the URL and re-parsed on the next render.
export type ComparisonRouteSearchInput = z.input<typeof comparisonRouteSearchSchema>;
